// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etHyUOMxhBIQDE_jgv8O{display:flex;flex-direction:column;row-gap:30px;width:400px}`, "",{"version":3,"sources":["webpack://./modules/Admin/System/Sitpanel/SitpanelSetting.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,YAAA,CACA,WAAA","sourcesContent":[".form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 30px;\r\n  width: 400px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": `etHyUOMxhBIQDE_jgv8O`
};
export default ___CSS_LOADER_EXPORT___;
